import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import PdfPreview from './PdfPreview';

const PreviewPDFEdit = ({ open, fileItem, onClose }) => {
  const title = fileItem?.downloadName || fileItem?.name || 'Anonymizovaný súbor';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>{title}</DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <PdfPreview fileBlob={fileItem?.blob} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Zavrieť</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewPDFEdit;
